import { LOGO_CREST, CONTACT } from "@/data/site";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-[#050505] border-t border-white/10">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-14">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          <img src={LOGO_CREST} alt="AS Auto Works" className="h-40 md:h-48 w-auto object-contain" />
          <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3">
            {["Services", "About", "Gallery", "Contact"].map((l) => (
              <button
                key={l}
                data-testid={`footer-link-${l.toLowerCase()}`}
                onClick={() => document.querySelector(`#${l.toLowerCase()}`)?.scrollIntoView({ behavior: "smooth" })}
                className="text-sm uppercase tracking-widest text-neutral-400 hover:text-gold transition-colors"
              >
                {l}
              </button>
            ))}
          </div>
        </div>
        <div className="mt-10 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-neutral-500">© {new Date().getFullYear()} AS Auto Works · Driven By Detail</p>
          <p className="text-sm text-neutral-500">{CONTACT.phone} · {CONTACT.email}</p>
        </div>
      </div>
    </footer>
  );
};
